import React from 'react'

interface Props {
  width: string
  height: string
  fill: string
}

export const IconActiveDomains = ({ width = '24px', height = '24px', fill = '#000' }: Props) => (
  <svg width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill={fill}>
      <path d="M12 2a10 10 0 1 0 6.32 17.74l1.93 1.93a1 1 0 0 0 1.41-1.41l-1.93-1.93A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"/>
      <path d="M10.5 13.5 8 11l-1.5 1.5L10.5 16l5-5-1.5-1.5z"/>
    </g>
  </svg>
)

export default IconActiveDomains
